<template>
  <button
    type="button"
    class="btn btn-gray"
    :class="buttonClassCalc"
    :disabled="isDisabled"
    @click.prevent="onClick">
    <span v-if="title">{{title}}</span>
    <span v-else-if="template !== null"
          v-html="textTemplate"></span>
    <template v-else>
      <i :class="`icon-db ${type}`"/>
      {{textControlTitle}}
    </template>
  </button>
</template>

<script>
export default {
  name: 'GridColumnControlsButton',
  props: {
    type: { type: String },
    row: { type: Object, required: true },
    template: { default: null },
    title: { type: String, default: '' },
    controlTitle: { type: [String, Function] },
    disabledExpression: { type: [String, Boolean, Function], default: 'false' },
    buttonClass: { type: [String, Function] }
  },
  computed: {
    isDisabled () {
      let expressionValue = String(this.checkEs6AndRun(this.disabledExpression, this.row))
      return expressionValue !== 'false'
    },
    textTemplate () {
      return this.template && this.template(this.row, this.$root)
    },
    textControlTitle () {
      return this.checkEs6AndRun(this.controlTitle, this.row)
    },
    buttonClassCalc () {
      return this.checkEs6AndRun(this.buttonClass, this.row)
    }
  },
  methods: {
    onClick () {
      if (this.isDisabled) return
      this.$emit('onClick')
    }
  }
}
</script>
